import { Button, CircularProgress, Grid, Skeleton, Stack, TableCell, Typography } from '@mui/material';
import { AssignedUsersCells, assignUser, changePassword, editUserProfile, getAssignedUsers, getUsers } from 'framework/user';
import useFetchSection from 'hooks/useFetchSection';
import List from '../List';
import EmptyContent from 'components/EmptyContent';
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { IAssignedUsers, IUser } from 'models/user';
import { useEffect, useState } from 'react';
import { useAlert } from 'contexts/alertContext';
import { QueryClient, useMutation } from 'react-query';
import EditModalReseller from './partials/Edit';
import { IFormField } from 'models/app';
import { InputTypes } from 'constants/enums';
import { handleError } from 'helpers/utils';
import Form from '../Form';
import MuiButton from '../MuiButton';


function ChangePassword() {

    const [loading2, setLoading2] = useState(false)
    const [inputObj, setInputObj] = useState<{ newPassword: string }>({} as { newPassword: string });
    const handleChange = (name: string, value: any) => {
        setInputObj((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const { setAlert } = useAlert();


    const assignUserMutation = useMutation({
        mutationFn: (formData: FormData) => {
            const userId = localStorage.getItem('userId');
            if (!userId) throw new Error('User ID not found in localStorage');
            return editUserProfile(formData, userId);
        },
    });

    const handleClose = () => {
        setInputObj({} as { newPassword: string })
    }


    if (loading2)
        return (
            <Stack spacing={2} p={2}>
                {Array.from({ length: 10 }).map((_, i) => (
                    <Skeleton variant="rectangular" key={i} width="100%" height={30} />
                ))}
            </Stack>
        );


    let BasicFields: IFormField[] = [
        {
            name: 'newPassword',
            label: 'New Password',
            type: InputTypes.TEXT,
            placeholder: 'Type New Password',
            internalLabel: true,
            required: true
        }
    ];

    const handleAssign = async () => {
        try {
            setLoading2(true)
            let formData = new FormData()
            inputObj.newPassword && formData.append("Password", inputObj.newPassword);
            await assignUserMutation.mutateAsync(formData);
            setAlert({
                open: true,
                message: `Password Changed successfully`,
                type: "success",
            });
            setLoading2(false)
            handleClose()
        } catch (error: any) {
            setAlert({
                open: true,
                message: handleError(error) || "Something went wrong",
                type: "error",
            });
            setLoading2(false)
        }

    };

    return (
        <div>
            <Stack spacing={2} p={2} >
                <Form fields={BasicFields} onChange={handleChange} />
            </Stack>
            <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
                <MuiButton variant="contained"
                    sx={{ bgcolor: 'primary.main', color: 'white' }}
                    disabled={!inputObj.newPassword}
                    size='large' onClick={handleAssign}>
                    {'Change Password'}
                    <CircularProgress
                        size={10}
                        sx={{ mx: 2, display: loading2 ? "" : "none" }}
                    />
                </MuiButton>

            </Grid>
        </div>
    )
}

export default ChangePassword